@if (checked !== false) {
  <i class="material-icons">{{ checked === true ? 'check' : 'remove' }}</i>
}
